import React from 'react';

const TopTicker = () => {
    return (
        <div className="ticker-container">
            <div className="ticker-list">
                <div className="ticker-item">Flash sales! Get them while supply lasts!</div>
                <div className="ticker-item">Local pickup. Delivery Available.</div>
                <div className="ticker-item">Need Help? Call us now!</div>
                {/* Duplicate items for smooth loop */}
                <div className="ticker-item">Flash sales! Get them while supply lasts!</div>
                <div className="ticker-item">Local pickup. Delivery Available.</div>
                <div className="ticker-item">Need Help? Call us now!</div>
            </div>
        </div>
    );
};

export default TopTicker;
